import React from 'react';

import CustomButton from "components/CustomButton";

import ActionButtonContentContainer from "./ActionButtonContentContainer";

function EditButton({onClick}) {
    return (
        <CustomButton
            onClick={onClick}
            variant={'outlined'}
            color={'default'}
        >
            <ActionButtonContentContainer>
                <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'
                     strokeLinecap='round' strokeLinejoin='round'>
                    <line x1='18' y1='2' x2='22' y2='6'/>
                    <path d='M7.5 20.5L19 9l-4-4L3.5 16.5 2 22z'/>
                </svg>
                Modifier
            </ActionButtonContentContainer>
        </CustomButton>
    );
}

export default EditButton;
